import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Typography from '@mui/material/Typography';
import Spacings from '~/modules/ui-kit/spacings';
import LoadingView from '~/components/LoadingView';
import ScrollablePaper from '~/components/ScrollablePaper';
import { useCurrentNews } from '~/hooks/api/useCurrentNews';
import NewsCardEntry from './NewsCardEntry';
import messages from './messages';
import styles from './styles.module.css';

const NewsCard = () => {
  const [showRead, setShowRead] = useState(false);
  const { data: newsEntries, isLoading } = useCurrentNews();
  return (
    <div data-test="uncompleted-turn-reports-card">
      <ScrollablePaper title={<FormattedMessage {...messages.news} />}>
        {!newsEntries || isLoading ? (
          <Spacings.Inset>
            <LoadingView hideLabel />
          </Spacings.Inset>
        ) : (
          <>
            {newsEntries
              .filter(
                (newsEntry) =>
                  typeof newsEntry.isRead === 'string' &&
                  ['Unread', 'ReadButChanged'].includes(newsEntry.isRead)
              )
              .map((newsEntry) => (
                <NewsCardEntry key={newsEntry.id} newsEntry={newsEntry} />
              ))}
            <>
              <button
                type="button"
                onClick={() => setShowRead((prev) => !prev)}
                className={styles.expander}
              >
                <Spacings.Inline alignItems="center" scale="s">
                  {showRead ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                  <div>
                    <Typography>
                      {showRead ? (
                        <FormattedMessage {...messages.hideReadNews} />
                      ) : (
                        <FormattedMessage
                          {...messages.showReadNews}
                          values={{
                            numberOfNews: newsEntries.filter(
                              (newsEntry) => newsEntry.isRead === 'Read'
                            ).length,
                          }}
                        />
                      )}
                    </Typography>
                  </div>
                </Spacings.Inline>
              </button>

              {showRead &&
                newsEntries
                  .filter((newsEntry) => newsEntry.isRead === 'Read')
                  .map((newsEntry) => (
                    <NewsCardEntry key={newsEntry.id} newsEntry={newsEntry} />
                  ))}
            </>
          </>
        )}
      </ScrollablePaper>
    </div>
  );
};

export default NewsCard;
